<script setup lang="ts">
import AppHeader from './AppHeader.vue'
import AppFooter from './AppFooter.vue'
import AskMairaWidget from './AskMairaWidget.vue'
import AppProgressBar from '@/components/ui/AppProgressBar.vue'
</script>

<template>
  <div class="flex flex-col min-h-screen">
    <AppProgressBar />
    <AppHeader />
    <main class="flex-1">
      <RouterView />
    </main>
    <AppFooter />
    <AskMairaWidget />
  </div>
</template>
